import { __extends } from "tslib";
import { AbstractionBase } from "@awayjs/core";
import { RenderableEvent } from '../events/RenderableEvent';
/**
 * @class away.pool.RenderEntity
 */
var RenderEntity = /** @class */ (function (_super) {
    __extends(RenderEntity, _super);
    /**
     * //TODO
     *
     * @param materialClassGL
     */
    function RenderEntity(stage, entity, renderGroup) {
        var _this = _super.call(this, entity, renderGroup) || this;
        _this._abstractionPool = new Object();
        _this._stage = stage;
        _this._renderGroup = renderGroup;
        _this._onInvalidateElementsDelegate = function (event) { return _this._onInvalidateElements(event); };
        _this._onInvalidateMaterialDelegate = function (event) { return _this._onInvalidateMaterial(event); };
        _this._onInvalidateStyleDelegate = function (event) { return _this._onInvalidateStyle(event); };
        _this._asset.addEventListener(RenderableEvent.INVALIDATE_ELEMENTS, _this._onInvalidateElementsDelegate);
        _this._asset.addEventListener(RenderableEvent.INVALIDATE_MATERIAL, _this._onInvalidateMaterialDelegate);
        _this._asset.addEventListener(RenderableEvent.INVALIDATE_STYLE, _this._onInvalidateStyleDelegate);
        return _this;
    }
    Object.defineProperty(RenderEntity.prototype, "stage", {
        /**
         *
         * @returns {RenderGroup}
         */
        get: function () {
            return this._stage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RenderEntity.prototype, "entity", {
        /**
         *
         * @returns {IRenderEntity}
         */
        get: function () {
            return this._asset;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RenderEntity.prototype, "renderGroup", {
        /**
         *
         * @returns {IRenderEntity}
         */
        get: function () {
            return this._renderGroup;
        },
        enumerable: true,
        configurable: true
    });
    RenderEntity.prototype.onClear = function (event) {
        this._asset.removeEventListener(RenderableEvent.INVALIDATE_ELEMENTS, this._onInvalidateElementsDelegate);
        this._asset.removeEventListener(RenderableEvent.INVALIDATE_MATERIAL, this._onInvalidateMaterialDelegate);
        this._asset.removeEventListener(RenderableEvent.INVALIDATE_STYLE, this._onInvalidateStyleDelegate);
        //clear all renderables associated with this render entity
        for (var key in this._abstractionPool)
            this._abstractionPool[key].onClear(null);
        _super.prototype.onClear.call(this, event);
    };
    RenderEntity.prototype._onInvalidateElements = function (event) {
        for (var key in this._abstractionPool)
            this._abstractionPool[key]._onInvalidateElements();
    };
    RenderEntity.prototype._onInvalidateMaterial = function (event) {
        for (var key in this._abstractionPool)
            this._abstractionPool[key]._onInvalidateMaterial();
    };
    RenderEntity.prototype._onInvalidateStyle = function (event) {
        for (var key in this._abstractionPool)
            this._abstractionPool[key]._onInvalidateStyle();
    };
    /**
     * //TODO
     *
     * @param renderable
     * @returns IRenderState
     */
    RenderEntity.prototype.getAbstraction = function (renderable) {
        return this._abstractionPool[renderable.id] || (this._abstractionPool[renderable.id] = new RenderEntity._renderRenderableClassPool[renderable.assetType](renderable, this));
    };
    /**
     *
     * @param renderable
     */
    RenderEntity.prototype.clearAbstraction = function (renderable) {
        delete this._abstractionPool[renderable.id];
    };
    /**
     *
     * @param imageObjectClass
     */
    RenderEntity.registerRenderable = function (renderStateClass, assetClass) {
        RenderEntity._renderRenderableClassPool[assetClass.assetType] = renderStateClass;
    };
    RenderEntity._renderRenderableClassPool = new Object();
    return RenderEntity;
}(AbstractionBase));
export { RenderEntity };
